<template>
  <v-container
    class="main-container overflow-y-auto fill-height d-flex align-center flex-wrap hide-scrollbar"
    fluid
  >
    <slot></slot>
  </v-container>
</template>
